import { type IBankAccountQuery } from 'application/querySchemas/IBankAccountQuery';
import { type ISupportUserTokenRepository } from 'application/repositorySchemas/ISupportUserTokenRepository';
import { type IBankAccountClient } from 'interfaceAdapter/gatewaySchemas/IBankAccountClient';
import { inject, injectable } from 'tsyringe';
import { BankAccount } from 'ui/components/supporter/patterns/TransferList/BankAccountManagement';

@injectable()
export class BankAccountQuery implements IBankAccountQuery {
    constructor(
        @inject('ISupportUserTokenRepository')
        public readonly supportUserToken: ISupportUserTokenRepository,
        @inject('IBankAccountClient')
        public readonly bankAccountClient: IBankAccountClient,
    ) {}

    public async fetch(): Promise<BankAccount | null> {
        const { data, message } = await this.bankAccountClient.get({
            token: this.supportUserToken.get() || '',
        });
        if (message) {
            throw new Error(message);
        }
        return data || null;
    }
}
